import { render, staticRenderFns } from "./ThreeDimensionsDetail.vue?vue&type=template&id=dd9c5472"
import script from "./ThreeDimensionsDetail.vue?vue&type=script&lang=js"
export * from "./ThreeDimensionsDetail.vue?vue&type=script&lang=js"
import style0 from "./ThreeDimensionsDetail.vue?vue&type=style&index=0&id=dd9c5472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports